export default __webpack_public_path__ + "static/media/cv-logo.2cdb5df4.svg";